import React from 'react';
import { Redirect } from 'react-router-dom';

import { track } from '../../mixpanel';
import history from './../../history';
import View from 'components/View/View';
import Navbar from '../../components/View/Navbar/Navbar';
import NavbarTitle from '../../components/View/Navbar/NavbarTitle/NavbarTitle';
import NavbarLeft from '../../components/View/Navbar/NavbarLeft/NavbarLeft';
import NavbarRight from '../../components/View/Navbar/NavbarRight/NavbarRight';
import NavbarButton from '../../components/View/Navbar/NavbarButton/NavbarButton';
import Page from '../../components/View/Page/Page';
import PageContent from '../../components/View/PageContent/PageContent';
import { getBarWeight } from '../Warmup/utils';

import PlateIcon from './PlateIcon/PlateIcon';
import platesForSide from './platesForSide';
import { setsLabel } from './weightRows';
import styles from './Plate.module.css';

function Plates(props) {
  // A direct visit or restored tab can have a URL without the workout's state.
  if (!props.location.state) {
    return <Redirect to="/" />;
  }

  return <PlateCalculator {...props.location.state} />;
}

// State is either { weight } (one weight, and every warmup) or { rows: [{ weight, sets }] } when a
// lift has several weights (#51); see weightRows.js.
function PlateCalculator({ weight, rows, subtitle, exerciseId }) {
  const blocks = Array.isArray(rows) && rows.length > 0 ? rows : [{ weight }];

  React.useEffect(() => {
    track('Plates Opened');
  }, []);

  return (
    <View>
      <Navbar>
        <NavbarLeft>
          <NavbarButton clicked={history.goBack}>close</NavbarButton>
        </NavbarLeft>
        <NavbarTitle title="Plates" subtitle={subtitle} />
        <NavbarRight empty/>
      </Navbar>

      <Page>
        <PageContent withNavbar whiteBg>
          {blocks.map((block, index) => (
            <WeightBlock
              key={`${block.weight}-${index}`}
              weight={block.weight}
              sets={block.sets}
              exerciseId={exerciseId}
              divided={index > 0}
            />
          ))}
        </PageContent>
      </Page>
    </View>
  )
}

export default Plates;

function WeightBlock({ weight, sets, exerciseId, divided }) {
  const barWeight = getBarWeight(exerciseId, weight);
  const platesWeights = platesForSide((weight - barWeight) / 2);

  return (
    <div className={divided ? styles.divided : undefined}>
      <div className={styles.title}>{weight} LBS</div>
      <Subtitle hasPlates={platesWeights.length > 0} sets={sets} />
      <div className={styles.iconsWrapper}>
        {platesWeights.map((plate, index) => <PlateIcon key={`${plate}${index}`} weight={plate} />)}
      </div>
    </div>
  );
}

function Subtitle({ hasPlates, sets }) {
  const plates = hasPlates ? 'Plates for each side (lbs):' : 'No plates on bar';
  if (!sets || sets.length === 0) {
    return <div className={styles.subtitle}>{plates}</div>;
  }

  return (
    <div className={styles.subtitle}>
      {setsLabel(sets)} · {plates.charAt(0).toLowerCase() + plates.slice(1)}
    </div>
  );
}
